
const baseUrl = process.env.apiURL || 'https://backend.melodahouse.com/api/v1';
const apiUri= `${baseUrl}/portfolio`;

export default apiUri;